import _ from 'lodash';
import Api from 'tm3-core/api';

class SessionStore {
  onCreate(request) {
    return Api.post('/api/session/create', request);
  }

  onUpdate(req) {
    return Api.post('/api/session/update', req);
  }

  onRemove(id, isSpecial, all, includePast) {
    let request = {
      id: id,
      all: all,
      isSpecial: isSpecial,
      includePast: includePast
    };

    return Api.post('/api/session/delete', request);
  }
}

export default new SessionStore();
